import React, { useMemo } from 'react';
import { PropertyKey, TargetNumberDto } from 'src/api/v2';
import useTargetNumbers from '../../hooks/useTargetNumbers';
import { useParams } from 'react-router-dom';
import { lowercaseFirstLetter } from './Integer';
import { newValueDto } from '../../hooks/useAchievedGoalsColumns';
import { RadioButton } from '@innovationnorway/component-library';

type Props = {
  targetNumber: TargetNumberDto;
  objectKey: PropertyKey;
  editMode: boolean;
};

const BoolCell = ({ targetNumber, objectKey, editMode }: Props) => {
  const { goalId } = useParams();
  const idArray = goalId?.split('|') || [];
  const { updateMutation } = useTargetNumbers(idArray[0] || '', idArray[1] || '');

  const onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const newDto = { ...newValueDto };
    newDto[lowercaseFirstLetter(objectKey)] = e.currentTarget.value === 'yes' ? true : false;

    updateMutation.mutateAsync([
      {
        ...targetNumber,
        valueDto: newDto,
      },
    ]);
  };

  const options = useMemo(() => {
    return [
      {
        selected:
          targetNumber.valueDto && !targetNumber.valueDto[lowercaseFirstLetter(objectKey)] ? true : false,
        value: 'No',
        text: 'Nei',
      },
      {
        selected:
          targetNumber.valueDto && targetNumber.valueDto[lowercaseFirstLetter(objectKey)] ? true : false,
        value: 'yes',
        text: 'Ja',
      },
    ];
  }, [objectKey, targetNumber.valueDto]);

  const displayText = useMemo(() => {
    if (targetNumber.valueDto && targetNumber.valueDto[lowercaseFirstLetter(objectKey)] === undefined) {
      return 'Ikke besvart';
    } else if (targetNumber.valueDto && targetNumber.valueDto[lowercaseFirstLetter(objectKey)] === false) {
      return 'Nei';
    } else if (targetNumber.valueDto && targetNumber.valueDto[lowercaseFirstLetter(objectKey)] === true) {
      return 'Ja';
    }
    return '';
  }, [objectKey, targetNumber.valueDto]);

  return editMode ? (
    <RadioButton
      name={targetNumber.sivaContractId.toString() + targetNumber.goalTemplateId}
      onChange={onChange}
      className="gap--2"
      hideLabel
      layout="horizontal"
      options={options}
    ></RadioButton>
  ) : (
    <>{displayText}</>
  );
};

export default BoolCell;
